import {
    TAB_INDEX_FOCUSABLE_ONLY,
    TAB_INDEX_FOCUSABLE_TAB_SEQUENCE,
} from "@multiweb/reactUtils";

export const getTabIndexByMultiselectMode = (multiselectMode: boolean): number => {
    return multiselectMode ? TAB_INDEX_FOCUSABLE_TAB_SEQUENCE : TAB_INDEX_FOCUSABLE_ONLY;
};
